import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { GivenCansForm } from "../components";

export const CreateGivenCans: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const productId = searchParams.get("productId");
  const customerId = searchParams.get("customerId");

  return (
    <>
      <Header
        title="Distribution gratuite"
        subtitle="Enregistrer une nouvelle distribution"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/given-cans`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvelle distribution" />
          <GivenCansForm
            productId={productId ? +productId : undefined}
            customerId={customerId ? +customerId : undefined}
            onCompleted={() => navigate("/given-cans")}
          />
        </div>
      </div>
    </>
  );
};
